const MiniRating4i = function () {
	let ratingSpot, isMobile, catAlias, reviewTab, dropdown, trigger,

	init = () => {
		if (document.getElementById('ratingSpot')) { //not on suspended item
			initVariables();
			fetchMiniRating();
		}
	},
	initVariables = () => {
		ratingSpot = document.getElementById('ratingSpot');
		isMobile = getComputedStyle(document.getElementById('checkIfMobile')).display == 'none';
		catAlias = document.getElementById('CatalogAlias').value;
		//may not be visible yet
		reviewTab = document.getElementById("reviewsTS") ? document.getElementById("reviewsTS") : "";
	},
	events = e => {
		if(e.target.id == "miniReviewLink"){
			e.preventDefault();
			showHide();
		}else if(e.target.classList.contains("allReviews")){
			e.preventDefault();
			goToReviews();
		}	
	},
	open = () => {
		trigger.setAttribute("aria-expanded", "true");
		dropdown.classList.remove("hide");
		dropdown.setAttribute("aria-hidden", "false");
		ratingSpot.addEventListener('keydown', closeOnEsc);
	},
	close = () => {
		trigger.setAttribute("aria-expanded", "false");
		dropdown.classList.add("hide");
		dropdown.setAttribute("aria-hidden", "true");
		ratingSpot.removeEventListener('keydown', closeOnEsc);
	},
	showHide = () => {
		if (trigger.getAttribute("aria-expanded") == "false") 
			open();
		else 
			close();
	},
	closeOnEsc = e => {
		if (e.keyCode == 27) {
			close();
			trigger.focus();
		}
	},
	waitForTabsToAppear = (activatedTabId) => {
		document.querySelector("#detailTabs").scrollIntoView();
		
		//allow the tabs to 'appear'
		const callback = function(mutationsList, observer) {
			for (let i = 0; i < mutationsList.length; i++) {
 				if (mutationsList[i].type === 'childList') {
					let tab = document.getElementById(activatedTabId);
 					tab.click();
 					tab.focus();
 					tabObserver.disconnect();
				}
			}
		};
		const tabObserver = new MutationObserver(callback);
		tabObserver.observe(document.getElementById('detailTabs'), { 
			childList: true, 
			subtree: true 
		});
	},
	goToReviews = () => { 
		if (document.querySelector('a.anchor[name="reivews"]')) { return; }
		close();

		//if the tabs haven't appeared on the page yet
		if(reviewTab == ""){
			waitForTabsToAppear("reviewsTS");
		}else{
			reviewTab.click();
			reviewTab.focus();
		}
	},
	fetchMiniRating = () => {
		fetch('/productmvc/minirating', {
			method: 'POST',
			body: JSON.stringify(catAlias),
			headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'fetch' }
		}).then(function (response) {
			return (response.ok) ? response.text() : []; // response.text() returns a promise
		}).then(function (response) {
			ratingSpot.innerHTML = response;
			ratingSpot.addEventListener("click", events);
			dropdown = ratingSpot.querySelector(".ministarsDropDown");
			trigger = document.getElementById("miniReviewLink");
		});
	};
	return {
		Init: init
	};
};